import { connect } from "react-redux";
import Dashboard from "../components/Dashboard";
import { loadInterests } from '../actions/userActions';
import { setAnnoucementListener } from "../actions/landlordActions";

function mapStateToProps( state, ownProps ) {
    return {
			user: state.user.data,
            interests: state.user.interests,
            favoriteMatches: state.user.matches.filter(match => match.favorite),
            currentAnnouncement: state.user.data.isLandlord ? state.landlord.selectedAnnouncement : undefined
    }
}

function mapDispatchToProps( dispatch, ownProps ) {
    return {
        loadInterests: (announcementId) => dispatch(loadInterests(announcementId)),
        setAsListener: ( f ) => dispatch( setAnnoucementListener( f ) )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Dashboard );